import React from 'react'
import PropTypes from 'prop-types'
import isNil from 'lodash/isNil'
import { useIntl } from 'react-intl'

/**
 * Localized number
 */
const LocalizedNumber = ({ placeholder, value, children, ...props }) => {
  const intl = useIntl()
  const text = isNil(value) || isNaN(value) ? placeholder : intl.formatNumber(value, props)
  return children ? children(text) : <span title={text}>{text}</span>
}

LocalizedNumber.defaultProps = {
  placeholder: '--',
}

LocalizedNumber.propTypes = {
  /**
   * An empty placeholder if value is nil.
   */
  placeholder: PropTypes.string,
  /**
   * The number value.
   */
  value: PropTypes.number,
  /**
   * Transformation function taking the localized number result as parameter.
   */
  children: PropTypes.func,
}

export default LocalizedNumber
